import { render, staticRenderFns } from "./LessonHistory.vue?vue&type=template&id=d6bc4d1a&scoped=true&"
import script from "./LessonHistory.vue?vue&type=script&lang=js&"
export * from "./LessonHistory.vue?vue&type=script&lang=js&"
import style0 from "./LessonHistory.vue?vue&type=style&index=0&id=d6bc4d1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6bc4d1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDataTable,VPagination,VRow})
